<template>
  <a-layout class="myApplication">
    <a-card :bordered="false">
      <search-form :search-conditions="searchConditions" :query-params="queryParams" @query="query" @clear="clear"></search-form>
      <a-table class="tableList" :rowKey="record => record.apply_number || record.id" :columns="columns" :loading="loading" :dataSource="dataSource" :pagination="false" :customRow="customRow">
        <template slot="titleRender" slot-scope="text, record">
          <span>{{record.user_name}}提交的{{record.apply_type}}</span>
        </template>
        <template slot="abstractRender" slot-scope="text, record">
          <p v-if="record.form_type===7">申请类型：采购申请</p>
          <p v-else-if="record.form_type===6">申请类型：{{record.apply_detail_type}}</p>
          <div v-else>
            <p>{{record.apply_type}}类型：{{record.apply_detail_type}}</p>
            <p v-if="record.payee_name">收款方：{{record.payee_name}}</p>
            <p v-if="record.form_type!==6">{{record.apply_type}}总金额（{{record.money_type}}）：{{record.total_pay}}</p>
          </div>
        </template>
        <template slot="statusRender" slot-scope="text, record">
          <span :style="setStatusColor(text)">{{text}}</span>
        </template>
        <template slot="footer" slot-scope="currentPageData" v-if="dataSource.length<total">
          <p style="text-align:center">
            <span @click="loadMore" style="cursor:pointer">加载更多数据</span>
          </p>
        </template>
      </a-table>
    </a-card>
  </a-layout>
</template>

<script>
import SearchForm from "../../components/SearchForm.vue";
import {
  getSearchOptions,
  ApplyTypeUrl,
  StatusTypeListUrl
} from "../../services/CommonService.js";
import { getList } from "../../services/MyApplicationListService";

export default {
  components: {
    SearchForm
  },
  data() {
    return {
      loading: true,
      breadcrumb: [
        {
          label: "我的申请",
          path: ""
        }
      ],
      cardHeight: 0,
      searchConditions: [
        [
          {
            label: "申请类型",
            type: "select",
            field: "applyType",
            placeholder: "请选择",
            fetch: {
              url: ApplyTypeUrl,
              params: {}
            },
            options: [],
            // needDefault: true,
            hasAll: true
            // defaultVal: 'all',
          },
          {
            label: "状态",
            type: "select",
            field: "status",
            placeholder: "请选择",
            fetch: {
              url: StatusTypeListUrl,
              params: {}
            },
            options: []
          },
          {
            show: true,
            type: "btnGroup"
          }
        ],
        [
          {
            label: "提交审批时间",
            type: "range",
            field: "applyTime"
          },
          {
            show: false,
            type: "btnGroup"
          }
        ],
        [
          {
            label: "审批完成时间",
            type: "range",
            field: "approvedTime"
          },
          {
            show: false,
            type: "btnGroup"
          }
        ]
      ],
      columns: [
        {
          title: "申请标题",
          dataIndex: "title",
          width: 150,
          scopedSlots: { customRender: "titleRender" }
        },
        {
          title: "申请摘要",
          dataIndex: "abstract",
          width: 250,
          scopedSlots: { customRender: "abstractRender" }
        },
        {
          title: "发起时间",
          dataIndex: "apply_time",
          width: 150
        },
        {
          title: "审批完成时间",
          dataIndex: "approved_time",
          width: 150
        },
        {
          title: "付款完成时间",
          dataIndex: "paid_time",
          width: 150
        },
        {
          title: "状态",
          dataIndex: "status",
          width: 150,
          scopedSlots: { customRender: "statusRender" }
        }
      ],
      dataSource: [],
      tableData: [],
      total: 0,
      defaultApplyType: undefined,
      queryParams: {
        currentPage: 1,
        pageSize: 20,
        filter: "created_by_me",

        status: undefined,
        applyType: undefined,
        applyTime: [],
        // applyTimeEnd: undefined,
        approvedTime: []
        // approvedTimeEnd: undefined,
      }
    };
  },

  created() {
    if (this.$route.query && this.$route.query.apply_type) {
      this.defaultApplyType = Number(this.$route.query.apply_type);
    }
    this.queryParams.applyType = this.defaultApplyType
      ? this.defaultApplyType
      : "all";
    this.queryParamsInit = _.cloneDeep(this.queryParams);
    this.cardHeight = document.documentElement.clientHeight - 150;
    const vm = this;
    window.onresize = function() {
      vm.cardHeight = document.documentElement.clientHeight - 150;
    };
    this.getList();
    this.searchConditions.forEach(item => {
      item.forEach(child => {
        if (child.fetch && child.fetch.url) {
          this.fetchList(child);
        }
      });
    });
  },

  computed: {
    queryObj() {
      return {
        current_page: this.queryParams.currentPage,
        page_size: this.queryParams.pageSize,
        filter: this.queryParams.filter,
        apply_type:
          this.queryParams.applyType === "all"
            ? undefined
            : this.queryParams.applyType,
        status: this.queryParams.status,
        apply_time_start: this.queryParams.applyTime[0],
        apply_time_end: this.queryParams.applyTime[1],
        approved_time_start: this.queryParams.approvedTime[0],
        approved_time_end: this.queryParams.approvedTime[1]
      };
    }
  },

  methods: {
    fetchList(config) {
      config.loading = true;
      getSearchOptions(config.fetch.url, config.fetch.params).then(res => {
        if (res.status === "success") {
          config.options = res.data;
          if (config.hasAll) {
            config.options.unshift({
              id: "all",
              name: "全部"
            });
          }
        } else {
          this.$Message.error(res.message);
        }
        config.loading = false;
      });
    },

    customRow(record) {
      let vm = this;
      return {
        on: {
          click(event) {
            if (record.form_type === 1)
              vm.$router.replace({
                name: "myApplicationDetail",
                query: {
                  id: record.id
                }
              });
            if (record.form_type === 2)
              vm.$router.replace({
                name: "myReimbursementDetail",
                query: {
                  id: record.id
                }
              });
            if (record.form_type === 7)
              vm.$router.replace({
                name: "myPurchaseDetail",
                query: {
                  id: record.id
                }
              });
            if (record.form_type === 6)
              vm.$router.replace({
                name: "myBudgetApplicationDetail",
                query: {
                  id: record.id
                }
              });
            if (record.form_type === 8)
              vm.$router.replace({
                name: "myProExpendPaymentDetail",
                query: {
                  id: record.id
                }
              });
            if (record.form_type === 9)
              vm.$router.replace({
                name: "myProExpendReimbursementDetail",
                query: {
                  id: record.id
                }
              });
          }
        }
      };
    },

    getList() {
      this.loading = true;
      getList(this.queryObj).then(res => {
        if ((res.status = "success")) {
          this.total = res.total;
          this.dataSource = this.dataSource.concat(res.data);
        } else {
          this.$Message.error(res.message);
        }
        this.loading = false;
      });
    },

    query(e) {
      this.queryParams = _.cloneDeep(this.queryParamsInit);
      Object.assign(this.queryParams, e);
      this.dataSource = [];
      this.getList();
    },

    clear() {
      this.dataSource = [];
      this.queryParams = _.cloneDeep(this.queryParamsInit);
      this.getList();
    },

    loadMore() {
      this.queryParams.currentPage++;
      this.getList();
    },
    setStatusColor(text) {
      if (text === "审批中") {
        return { color: "#FF9500" };
      } else if (text === "审批通过" || text === "付款成功") {
        return { color: "#2DBE60" };
      } else if (text === "审批拒绝" || text === "付款失败") {
        return { color: "#FF4D07" };
      } else if (text === "已撤回") {
        return { color: "rgba(0,0,0,0.38)" };
      }
    }
  }
};
</script>

<style lang="less">
.oa-app .myApplication {
  padding: 16px;

  .ant-table-footer {
    text-align: center;
  }
}
.dd-oa-app .myApplication {
  padding: 0;
  > .ant-card > .ant-card-body {
    padding: 24px 0;
  }
  .ant-advanced-search-form {
    padding: 0 32px;
  }

  .ant-table-footer {
    text-align: center;
  }
}
</style>
